import {createContext, useContext} from 'react'

export const CuralateAPIContext = createContext()
export const CuralateAPIProvider = CuralateAPIContext.Provider
export const useCuralateAPI = () => useContext(CuralateAPIContext)
